/**
 * Fotos crowdsourced de láminas — los usuarios pueden subir foto de su lámina física.
 */
import { api, apiBaseUrl, getToken } from "./client";
import type { MatchUser } from "./matches";

export interface StickerPhoto {
  id: number;
  sticker_id: number;
  public_url: string;
  uploader: MatchUser | null;
  approved: boolean;
  is_primary: boolean;
  created_at: string;
}

export async function fetchStickerPhotos(stickerId: number, limit = 6): Promise<StickerPhoto[]> {
  return api<StickerPhoto[]>(`/stickers/${stickerId}/photos?limit=${limit}`);
}

/** Sube una foto. file es el File del input. Retorna la photo creada. */
export async function uploadStickerPhoto(stickerId: number, file: File): Promise<StickerPhoto> {
  const form = new FormData();
  form.append("file", file);

  const token = getToken();
  const headers: Record<string, string> = { Accept: "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const res = await fetch(`${apiBaseUrl()}/stickers/${stickerId}/photos`, {
    method: "POST",
    body: form,
    headers,
  });
  if (!res.ok) {
    let detail = "Error subiendo foto";
    try {
      const j = await res.json();
      detail = j.detail || detail;
    } catch { /* ignore */ }
    throw new Error(detail);
  }
  return res.json();
}

export async function deleteStickerPhoto(photoId: number): Promise<void> {
  await api(`/stickers/photos/${photoId}`, { method: "DELETE" });
}

export async function setPrimary(photoId: number): Promise<void> {
  await api(`/admin/sticker-photos/${photoId}/set-primary`, { method: "POST" });
}

/** Mapa { sticker_id: public_url } con todas las fotos primary del catálogo. */
export async function fetchPrimaryPhotos(): Promise<Record<number, string>> {
  return api<Record<number, string>>(`/stickers/photos/primaries`);
}
